export const SPEAKER_CREATE_RESET = 'SPEAKER_CREATE_RESET';
export const SPEAKER_CREATE_SET_CREATED = 'SPEAKER_CREATE_SET_CREATED';
export const SPEAKER_CREATE_SET_ERROR = 'SPEAKER_CREATE_SET_ERROR';
export const SPEAKER_CREATE_SET_VIOLATIONS = 'SPEAKER_CREATE_SET_VIOLATIONS';
export const SPEAKER_CREATE_TOGGLE_LOADING = 'SPEAKER_CREATE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/speaker/create/mutation_types.js